import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {Router} from "@angular/router";
import {ConfigService} from "../config.service";
import {LoginService} from "../login.service";
import { MdSnackBar } from '@angular/material';

@Injectable()
export class RequestInterceptor {

  constructor(
    private http: Http,
    private router: Router,
    private configService: ConfigService,
    private loginService: LoginService,
    private snackBar: MdSnackBar) {
  }

  // Intercept GET requests
  get(url: string, options?: RequestOptions): Observable<Response> {
    return this.http.get(url, options)
      // Catch errors with status code 401
      .catch((error: Response) => {
        if (error.status === 401) {

          // Snackbar pop-up to show the user
          this.snackBar.open('Login expired', 'Close', {
                duration: 3000,
          });

          // Navigate to login page
          this.router.navigate([this.configService.getLanguageFromURL() + '/login'], {
            queryParamsHandling: 'preserve'
          }).then(() =>
            // Clears cookies and tell session user is logged out
            this.loginService.logout()
          );
        }
        return Observable.throw(error);
      });
  }

  // Intercept PUT requests
  put(url: string, body: any, options?: RequestOptions): Observable<Response> {
    return this.http.put(url, body, options).do((res: Response): void => {
      // Put logic to do when intercepted here
    });
  }

  // Intercept POSt requests
  post(url: string, body: any, options?: RequestOptions): Observable<Response> {
    return this.http.post(url, body, options).do((res: Response): void => {
      // Put logic to do when intercepted here
    });
  }

  // Intercept DELETE requests
  delete(url: string, options?: RequestOptions): Observable<Response> {
    return this.http.delete(url, options).do((res: Response): void => {
      // Put logic to do when intercepted here
    });
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/Interceptors/RequestInterceptor.ts